import { applyAndroidKioskLock, exitAndroidKioskLock } from '@/helpers/androidKioskLock'
import { setAndroidMaintenanceSuppressUntil } from '@/helpers/androidProcessSelfHeal'

/** Same window as field-service unlock (`KIOSK_UNLOCK_WINDOW_MS`). */
export const SETUP_UNLOCK_WINDOW_MS = 15 * 60 * 1000

/**
 * Lock Task blocks Settings. First-run setup screens may drop kiosk without the field-service PIN so
 * the operator can change a system setting (see androidKioskLock.ts). Callers must re-arm with
 * {@link rearmKioskAfterSetup} when leaving the screen (done / skip / unmount).
 */
export async function unlockKioskForSetup(): Promise<void> {
  await exitAndroidKioskLock()
  await setAndroidMaintenanceSuppressUntil(Date.now() + SETUP_UNLOCK_WINDOW_MS)
}

export async function rearmKioskAfterSetup(): Promise<void> {
  // Drop the setup suppress window so self-heal / Lock Task resume normally.
  await setAndroidMaintenanceSuppressUntil(0)
  await applyAndroidKioskLock()
}
